var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14 0L14 14H10.92L10.9425 3.05747L0 3.08V5.34058e-07L14 0Z","fill":"#00FF85","key":0}),React.createElement("path",{"d":"M10.1541 1.79513L12.3941 4.03513L2.59411 13.8351L0.354111 11.5951L10.1541 1.79513Z","fill":"#00FF85","key":1})]);
}

Arrow.defaultProps = {"width":"100%","height":"100%","style":{"display":"block"},"viewBox":"0 0 14 14","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
